export const InvoiceSubContractorMixin = {
  data () {
    return {
      subContractors: [],
      subContractorOrderRows: {},
      subContractorId: 0,
      subContractorInfoText: ''
    }
  },
  computed: {
  },
  async mounted () {
  },
  methods: {
    iscmInitData (invoice) {
      if (invoice.subInvoice) {
        this.subContractorOrderRows = Object.assign({}, this.subContractorOrderRows, invoice.subInvoice.data)
        this.subContractorId = invoice.subInvoice.id
        this.subContractorInfoText = invoice.subInvoice.data.infoText
      }
    },
    async iscmSaveInvoice (parent, type) {
      let si = { id: 0 }
      if (!this._.isEmpty(this.subContractorOrderRows)) {
        if (!parent.subInvoice) {
          si = await this.$store.dispatch('ADD_SUB_INVOICE', {
            parentId: parent.id,
            name: parent.name,
            type: type,
            data: this.subContractorOrderRows
          })
        } else {
          si = await this.$store.dispatch('UPDATE_SUB_INVOICE', {
            id: parent.subInvoice.id,
            name: parent.name,
            data: this.subContractorOrderRows
          })
        }
      }
      this.subContractorId = si.id
    },
    iscmCreateInvoice (orderRows, subContractor, invoiceDate, dmt, dmtId, deliveryPeriod, marking, deliveryPlace, infoText) {
      if (orderRows.length === 0 && Object.keys(this.subContractorOrderRows).length === 0) {
        return
      }
      this.subContractorOrderRows = Object.assign({}, this.subContractorOrderRows, {
        subContractor: subContractor,
        invoiceDate: invoiceDate,
        dmt: dmt,
        dmtId: dmtId,
        period: deliveryPeriod,
        marking: marking,
        deliveryPlace: deliveryPlace,
        infoText: infoText,
        orderRows: orderRows
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/InvoiceSubContractorMixin.js